import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TcV2CheckoutTermsListComponent } from '@features/transfer-connect-v2/components/checkout-terms-list/checkout-terms-list.component';

@Component({
  selector: 'rd-anz-tcv2-checkout-terms-list',
  templateUrl:
    '../../../../../../../features/transfer-connect-v2/src/lib/components/checkout-terms-list/checkout-terms-list.component.html',
  styleUrls: ['./checkout-terms-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnzTcV2CheckoutTermsListComponent extends TcV2CheckoutTermsListComponent {
  @HostBinding('class.rd-anz-tcv2-checkout-terms-list') componentClass = true;
  @HostBinding('class.rounded-md-mobile') mobileRadius = true;
}
